import { onUnmounted, watch, type Ref } from 'vue'

type PaymentMethod = 'cash' | 'card' | 'digital' | 'other'

interface UsePosOrderShortcutsOptions {
  enabled: Ref<boolean>
  isOpen: Ref<boolean>
  markAsPaid: Ref<boolean>
  selectedPaymentMethod: Ref<PaymentMethod>
  hasItems: Ref<boolean>
  isPaymentValid: Ref<boolean>
  focusCashInput: () => void
  createOrder: () => void
}

export function usePosOrderShortcuts(options: UsePosOrderShortcutsOptions) {
  const handleKeyboardShortcuts = (event: KeyboardEvent) => {
    if (!options.enabled.value || !options.isOpen.value) return

    if (event.key === 'F2') {
      event.preventDefault()
      event.stopPropagation()

      if (options.markAsPaid.value && options.selectedPaymentMethod.value === 'cash') {
        options.focusCashInput()
      }

      return
    }

    if (event.key === 'F9') {
      event.preventDefault()
      event.stopPropagation()

      if (options.hasItems.value && options.isPaymentValid.value) {
        options.createOrder()
      }
    }
  }

  const attach = () => {
    window.addEventListener('keydown', handleKeyboardShortcuts, true)
  }

  const detach = () => {
    window.removeEventListener('keydown', handleKeyboardShortcuts, true)
  }

  watch(
    () => options.enabled.value,
    (isEnabled) => {
      if (isEnabled) {
        attach()
      } else {
        detach()
      }
    },
    { immediate: true }
  )

  onUnmounted(() => {
    detach()
  })
}
